export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  
  // 用户管理
  'pages.userManagement.title': '用户管理',
  'pages.userManagement.avatar': '头像',
  'pages.userManagement.openid': 'Open ID',
  'pages.userManagement.userId': '用户ID',
  'pages.userManagement.nickname': '昵称',
  'pages.userManagement.temporaryCredits': '临时积分',
  'pages.userManagement.permanentCredits': '永久积分',
  'pages.userManagement.adViewCredits': '广告次数',
  'pages.userManagement.createdAt': '创建时间',
  'pages.userManagement.actions': '操作',
  'pages.userManagement.edit': '编辑',
  'pages.userManagement.delete': '删除',
  'pages.userManagement.deleteConfirm.title': '确认删除',
  'pages.userManagement.deleteConfirm.content': '确定要删除用户 {nickname} 吗？',
  'pages.userManagement.deleteConfirm.ok': '删除',
  'pages.userManagement.deleteConfirm.cancel': '取消',
  'pages.userManagement.deleteSuccess': '用户删除成功',
  'pages.userManagement.deleteError': '删除用户失败',

  // 图像编辑管理页面
  'pages.imageEditManagement.title': '编辑记录',
  'pages.imageEditManagement.id': '记录ID',
  'pages.imageEditManagement.userId': '用户ID',
  'pages.imageEditManagement.prompt': '编辑提示词',
  'pages.imageEditManagement.originalImages': '原始图片',
  'pages.imageEditManagement.resultImage': '结果图片',
  'pages.imageEditManagement.hasTextContent': '文本内容',
  'pages.imageEditManagement.createdAt': '创建时间',
  'pages.imageEditManagement.actions': '操作',
  'pages.imageEditManagement.search': '搜索',
  'pages.imageEditManagement.reset': '重置',
  'pages.imageEditManagement.deleteConfirm.title': '确认删除',
  'pages.imageEditManagement.deleteConfirm.content': '确定要删除这条编辑记录吗？此操作不可撤销。',
  'pages.imageEditManagement.deleteConfirm.ok': '删除',
  'pages.imageEditManagement.deleteConfirm.cancel': '取消',
  'pages.imageEditManagement.deleteSuccess': '编辑记录删除成功',
  'pages.imageEditManagement.deleteError': '删除编辑记录失败',
  'pages.imageEditManagement.fetchError': '获取编辑记录失败',

  // 指令管理
  'pages.quickCommandManagement.title': '指令管理',
  'pages.quickCommandManagement.name': '指令名称',
  'pages.quickCommandManagement.description': '描述',
  'pages.quickCommandManagement.category': '分类',
  'pages.quickCommandManagement.prompt': '提示词',
  'pages.quickCommandManagement.enabled': '启用状态',
  'pages.quickCommandManagement.sortOrder': '排序',
  'pages.quickCommandManagement.createdAt': '创建时间',
  'pages.quickCommandManagement.updatedAt': '更新时间',
  'pages.quickCommandManagement.actions': '操作',
  'pages.quickCommandManagement.addNew': '新增指令',
  'pages.quickCommandManagement.addTitle': '新增指令',
  'pages.quickCommandManagement.editTitle': '编辑指令',
  'pages.quickCommandManagement.detail': '指令详情',
  'pages.quickCommandManagement.deleteConfirm': '确定要删除此指令吗？',
  'pages.quickCommandManagement.deleteWarning': '此操作不可撤销。',
  'pages.quickCommandManagement.deleteSuccess': '删除指令成功',
  'pages.quickCommandManagement.deleteError': '删除指令失败',
  'pages.quickCommandManagement.createSuccess': '创建指令成功',
  'pages.quickCommandManagement.createError': '创建指令失败',
  'pages.quickCommandManagement.updateSuccess': '更新指令成功',
  'pages.quickCommandManagement.updateError': '更新指令失败',
  'pages.quickCommandManagement.fetchError': '获取指令列表失败',
  'pages.quickCommandManagement.nameRequired': '请输入指令名称',
  'pages.quickCommandManagement.namePlaceholder': '请输入指令名称',
  'pages.quickCommandManagement.descriptionRequired': '请输入描述',
  'pages.quickCommandManagement.descriptionPlaceholder': '请输入指令描述',
  'pages.quickCommandManagement.categoryRequired': '请选择分类',
  'pages.quickCommandManagement.categoryPlaceholder': '请选择分类',
  'pages.quickCommandManagement.promptRequired': '请输入提示词',
  'pages.quickCommandManagement.promptPlaceholder': '请输入AI处理的实际提示词',
  'pages.quickCommandManagement.sortOrderPlaceholder': '请输入排序值，数字越小越靠前',
  'pages.quickCommandManagement.exampleImage': '示例图片',
  'pages.quickCommandManagement.exampleImagePlaceholder': '请输入图片URL（例如：https://example.com/image.jpg）',

  // 产品管理
  'pages.productManagement.title': '产品管理',
  'pages.productManagement.id': 'ID',
  'pages.productManagement.name': '产品名称',
  'pages.productManagement.type': '产品类型',
  'pages.productManagement.price': '价格',
  'pages.productManagement.value': '价值',
  'pages.productManagement.status': '状态',
  'pages.productManagement.stock': '库存',
  'pages.productManagement.soldCount': '销量',
  'pages.productManagement.sortOrder': '排序',
  'pages.productManagement.createdAt': '创建时间',
  'pages.productManagement.actions': '操作',
  'pages.productManagement.addNew': '新增产品',
  'pages.productManagement.statistics': '数据统计',
  'pages.productManagement.deleteConfirm': '确认删除',
  'pages.productManagement.deleteWarning': '确定要删除此产品吗？此操作不可撤销。',
  'pages.productManagement.deleteSuccess': '产品删除成功',
  'pages.productManagement.deleteError': '删除产品失败',
  'pages.productManagement.updateSuccess': '产品更新成功',
  'pages.productManagement.updateError': '更新产品失败',
  'pages.productManagement.adding': '添加中...',
  'pages.productManagement.addSuccess': '产品添加成功',
  'pages.productManagement.addError': '添加产品失败，请重试！',
  'pages.productManagement.updating': '更新中...',

  // 订单管理
  'pages.orderManagement.title': '订单管理',
  'pages.orderManagement.orderNo': '订单号',
  'pages.orderManagement.userId': '用户ID',
  'pages.orderManagement.userName': '用户名称',
  'pages.orderManagement.userEmail': '用户邮箱',
  'pages.orderManagement.productId': '商品ID',
  'pages.orderManagement.productName': '商品名称',
  'pages.orderManagement.productType': '商品类型',
  'pages.orderManagement.amount': '订单金额',
  'pages.orderManagement.originalAmount': '原价',
  'pages.orderManagement.discountAmount': '折扣金额',
  'pages.orderManagement.finalAmount': '实付金额',
  'pages.orderManagement.paymentMethod': '支付方式',
  'pages.orderManagement.paymentStatus': '支付状态',
  'pages.orderManagement.orderStatus': '订单状态',
  'pages.orderManagement.paymentTime': '支付时间',
  'pages.orderManagement.completeTime': '完成时间',
  'pages.orderManagement.refundTime': '退款时间',
  'pages.orderManagement.refundAmount': '退款金额',
  'pages.orderManagement.refundReason': '退款原因',
  'pages.orderManagement.createdAt': '创建时间',
  'pages.orderManagement.actions': '操作',
  'pages.orderManagement.orderDetail': '订单详情',
  'pages.orderManagement.refund': '退款',
  'pages.orderManagement.refundOrder': '退款订单',
  'pages.orderManagement.confirmRefund': '确认退款',
  'pages.orderManagement.export': '导出',
  'pages.orderManagement.statistics': '数据统计',
  'pages.orderManagement.deleteConfirm': '确认删除',
  'pages.orderManagement.deleteWarning': '确定要删除此订单吗？此操作不可撤销。',
  'pages.orderManagement.deleteSuccess': '订单删除成功',
  'pages.orderManagement.deleteError': '删除订单失败',
  'pages.orderManagement.updateSuccess': '订单更新成功',
  'pages.orderManagement.updateError': '更新订单失败',
  'pages.orderManagement.refundSuccess': '退款成功',
  'pages.orderManagement.refundError': '退款失败',
  'pages.orderManagement.exportSuccess': '导出成功',
  'pages.orderManagement.exportError': '导出失败',
  'pages.orderManagement.remark': '备注',
  'pages.orderManagement.stats.totalOrders': '总订单数',
  'pages.orderManagement.stats.totalAmount': '总交易额',
  'pages.orderManagement.stats.totalPaidAmount': '总支付金额',
  'pages.orderManagement.stats.totalRefundAmount': '总退款金额',
  'pages.orderManagement.stats.pendingOrders': '待处理订单',
  'pages.orderManagement.stats.paidOrders': '已支付订单',
  'pages.orderManagement.stats.completedOrders': '已完成订单',
  'pages.orderManagement.stats.cancelledOrders': '已取消订单',
  'pages.orderManagement.stats.refundedOrders': '已退款订单',
  'pages.orderManagement.stats.todayOrders': '今日订单',
  'pages.orderManagement.stats.todayAmount': '今日交易额',
  'pages.orderManagement.stats.creditsOrders': '积分订单',
  'pages.orderManagement.stats.membershipOrders': '会员订单',
  'pages.orderManagement.stats.completionRate': '完成率',

  // 券码管理
  'pages.couponManagement.title': '券码管理',
  'pages.couponManagement.code': '券码',
  'pages.couponManagement.productName': '关联商品',
  'pages.couponManagement.productType': '商品类型',
  'pages.couponManagement.value': '价值',
  'pages.couponManagement.batchName': '批次名称',
  'pages.couponManagement.status': '状态',
  'pages.couponManagement.usedBy': '使用者',
  'pages.couponManagement.usedAt': '使用时间',
  'pages.couponManagement.expiresAt': '过期时间',
  'pages.couponManagement.createdAt': '创建时间',
  'pages.couponManagement.actions': '操作',
  'pages.couponManagement.generate': '生成券码',
  'pages.couponManagement.batchEnable': '批量启用',
  'pages.couponManagement.batchDisable': '批量禁用',
  'pages.couponManagement.export': '导出选中',
  'pages.couponManagement.statistics': '数据统计',
  'pages.couponManagement.deleteConfirm': '确认删除',
  'pages.couponManagement.deleteWarning': '确定要删除此券码吗？此操作不可撤销。',
  'pages.couponManagement.deleteSuccess': '券码删除成功',
  'pages.couponManagement.deleteError': '删除券码失败',
  'pages.couponManagement.generateSuccess': '券码生成成功',
  'pages.couponManagement.generateError': '生成券码失败',
  'pages.couponManagement.copySuccess': '券码已复制到剪贴板',
  'pages.couponManagement.copyError': '复制失败',

  // 通用
  'common.view': '查看',
  'common.edit': '编辑',
  'common.delete': '删除',
  'common.confirm': '确认',
  'common.cancel': '取消',
  'common.create': '创建',
  'common.update': '更新',
  'common.search': '搜索',
  'common.reset': '重置',
  'common.submit': '提交',
  'common.save': '保存',
  'common.enable': '启用',
  'common.disable': '停用',
  'common.detail': '详情',
  'common.refresh': '刷新',
};
